import type { Substance } from '../types';

export const thc: Substance = {
  id: 'thc',
  displayName: 'THC (Cannabis)',
  emoji: '🌿',
  aliases: ['thc', 'cannabis', 'weed', 'marijuana'],
  substanceClass: 'cannabinoid',
  mechanismSummary:
    'Partial agonist at CB1, the most abundant GPCR in the CNS, modulating transmitter release broadly. ' +
    'CB1 is also dense in the enteric nervous system, which is where the appetite and nausea effects come ' +
    'from. Oral bioavailability is low and variable due to extensive first-pass metabolism, and real ' +
    'elimination is multiphasic with a long tail from fat stores that this single-phase model does not capture.',
  pk: {
    route: 'oral',
    ka: 0.8,
    ke: 0.1155,
    vd: 280,
    bioavailability: 0.08,
    molecularWeightGMol: 314.46,
    brainPlasmaRatio: 1.3,
  },
  doseRange: { min: 2, max: 25, default: 10, step: 1, unit: 'mg', displayScale: 1 },
  bindings: [
    {
      receptor: 'CB1',
      kiNM: 40,
      action: 'partial-agonist',
      citation:
        'Reported range ~6-40 nM across studies; using the classic figure. Showalter VM et al. (1996) ' +
        'J Pharmacol Exp Ther 278:989-999. PMID: 8819477; Pertwee RG (2008) Br J Pharmacol 153:199-215.',
    },
    {
      receptor: 'CB2',
      kiNM: 36,
      action: 'partial-agonist',
      citation: 'Showalter VM et al. (1996) J Pharmacol Exp Ther 278:989-999. PMID: 8819477.',
    },
  ],
  colorPalette: { primary: '#55aa44', secondary: '#448833', particleSpeedMultiplier: 0.8 },
};

export const cbd: Substance = {
  id: 'cbd',
  displayName: 'CBD (Cannabidiol)',
  emoji: '🍃',
  aliases: ['cbd', 'cannabidiol'],
  substanceClass: 'cannabinoid',
  mechanismSummary:
    'Despite coming from the same plant, CBD is NOT a CB1 agonist and is not intoxicating — its affinity ' +
    'for CB1 is very weak. Its effects are attributed to other targets including 5-HT1A and negative ' +
    'allosteric modulation of CB1, and it can blunt some of THC\'s effects rather than adding to them. A ' +
    'useful demonstration that "from cannabis" says almost nothing about mechanism.',
  pk: {
    route: 'oral',
    ka: 0.7,
    ke: 0.099,
    vd: 2500,
    bioavailability: 0.06,
    molecularWeightGMol: 314.46,
    brainPlasmaRatio: 1.2,
  },
  doseRange: { min: 5, max: 200, default: 50, step: 5, unit: 'mg', displayScale: 1 },
  bindings: [
    {
      receptor: 'CB1',
      kiNM: 4900,
      action: 'negative-modulator',
      citation:
        'Very weak direct affinity; CBD acts largely as a negative allosteric modulator at CB1 rather than ' +
        'an agonist. Pertwee RG (2008) Br J Pharmacol 153:199-215. PMID: 17828291.',
    },
    {
      receptor: '5HT1A',
      kiNM: 16000,
      action: 'agonist',
      citation:
        'Weak but repeatedly implicated in CBD\'s anxiolytic effects. Approximate — see Russo EB et al. ' +
        '(2005) Neurochem Res 30:1037-1043.',
    },
  ],
  colorPalette: { primary: '#88cc99', secondary: '#559977', particleSpeedMultiplier: 0.9 },
};

export const CANNABINOIDS = [thc, cbd];
